import clsx from 'clsx';
import { h } from 'preact';
import SubMenuItems from './submenu-items';

const SubMenuTabs = ({
  menu,
  activeMenu,
  activeTab,
  setActiveTab,
  setActiveMenu,
  isVoyagesLayout,
}) => {
  const tabsHeadings = menu.map((m) => m.title);
  const tabsClasses = {
    dark: {
      active: 'text-neutral bg-white-90',
      inactive: 'text-neutral bg-transparent',
    },
    light: {
      active: 'text-black bg-cream-grey',
      inactive: 'text-charcoal bg-neutral',
    },
  };

  return (
    <div className="flex items-start justify-start gap-[47px] pb-10">
      <div className={clsx(
        'flex-[0_0_200px] flex flex-col rounded-[4px] border overflow-hidden',
        isVoyagesLayout ? 'border-white-50' : 'border-black-30',
      )}>
        {tabsHeadings.map((title, index) => (
          <div key={`${title}-${index}`}>
            <p
              className={clsx(
                'cursor-pointer px-6 pt-4 pb-3 cta-small uppercase',
                tabsClasses[isVoyagesLayout ? 'dark' : 'light'][activeTab === index ? 'active' : 'inactive'],
              )}
              onClick={() => {
                setActiveTab(index);
                setActiveMenu(menu[index].submenus);
              }}
            >
              {title}
            </p>
          </div>
        ))}
      </div>
      <SubMenuItems menu={activeMenu} isVoyagesLayout={isVoyagesLayout}/>
    </div>
  );
};

export default SubMenuTabs;
